import { render, staticRenderFns } from "./genres-list.vue?vue&type=template&id=1e5510e2&scoped=true"
import script from "./genres-list.vue?vue&type=script&lang=js"
export * from "./genres-list.vue?vue&type=script&lang=js"
import style0 from "./genres-list.vue?vue&type=style&index=0&id=1e5510e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5510e2",
  null
  
)

export default component.exports